import { lazyNamed } from 'src/utils/lazyNamed';

export const CreativesApproval = {
  CreativesApprovalList: lazyNamed(() => import('./containers/CreativesApprovalList'), 'CreativesApprovalList'),
};
